export const validate = (value, validations, l) => {
    let error = null;
    if (!validations) return { error };
    for (let validation of validations) {
        error = error ? error : valid[validation](value);
    }
    return { error };
};

const isEmail = value => {
    const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if( !value || regex.test(value) ) {
        return null;
    }

    return 'Please provide valid e-mail.';
};

const isOnlyText = value => {
    const regex = /^[a-zA-Z]*$/;
    if(!value || regex.test(value) ) {
        return null;
    }

    return 'Valid characters are A-z.';
};

const isOnlyNumbers = value => {
    const regex = /^\d+$/;
    if(!value || regex.test(value) ) {
        return null;
    }

    return 'Valid characters include 0-9.';
};

const isOnlyNumbersAndLatters = value => {
    const regex = /^[a-zA-Z0-9]*$/;
    if(!value || regex.test(value) ) {
        return null;
    }

    return 'Valid characters include A-z, 0-9.';
};

const isNotEmpty = value => value ? null : "This field is mandatory.";

const image = value => {
    if (!value) return 'This field is mandatory.';
    if(value.indexOf('data:image') === -1) {
        return "Valid formats are JPG and PNG.";
    }
    return null;
};

const valid = {
    email: isEmail,
    onlyText: isOnlyText,
    onlyNumbers: isOnlyNumbers,
    required: isNotEmpty,
    onlyNumbersAndLetters: isOnlyNumbersAndLatters,
    image: image
};


// WEBPACK FOOTER //
// ./src/utils/validation.js